import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./components/Services";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import chatbot from "./components/chatbot";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ServiceDetails from "./pages/ServiceDetails";

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:type" element={<ServiceDetails />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/chatbot" element={<chatbot />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;